// extracted by mini-css-extract-plugin
export default {"header":"Header_header__GoaIv","header__title":"Header_header__title__HWH37","header__description":"Header_header__description__h+kp8"};